import { Company } from "@/common/types";
import { ChevronIcon } from "@/components/icon";
import {
  DefaultHeadColumns,
  DefaultTextColumn,
  TableCellWithTime,
} from "@/components/TableComponents";

const globalQuoteStrategy = [
  {
    title: <DefaultHeadColumns text="Quote ID" />,
    dataIndex: "id",
    key: "id",
    render: (value: number) => <div key={value}>{value}</div>,
  },

  {
    title: <DefaultHeadColumns text="Customer Name" />,
    dataIndex: "initiator",
    key: "customerName",
    render: (value: Company) => (
      <DefaultTextColumn
        text={value.companyName}
        key={value.id}
        className="py-0"
      />
    ),
  },

  {
    title: <DefaultHeadColumns text="End Customer Name" />,
    dataIndex: "endCustomerName",
    key: "endCustomerName",
    render: (value: string) => (
      <DefaultTextColumn text={value} key={value} className="py-0" />
    ),
  },
  {
    title: <DefaultHeadColumns text="Project Number" />,
    dataIndex: "customerProjectNumber",
    key: "customerProjectNumber",
    render: (value: string) => (
      <DefaultTextColumn text={value} key={value} className="py-0" />
    ),
  },
  {
    title: <DefaultHeadColumns text="Required By" />,
    dataIndex: "dueDate",
    key: "dueDate",
    render: (value: string, record: any) => (
      <TableCellWithTime
        value={value}
        key={record.id}
        className="py-0"
        format="DD-MM-YYYY"
      />
    ),
  },
  {
    title: <DefaultHeadColumns text="RFS Date" />,
    dataIndex: "RFSdate",
    key: "RFSdate",
    render: (value: string, record: any) => (
      <TableCellWithTime
        value={value}
        key={record.id}
        className="py-0"
        format="DD-MM-YYYY"
      />
    ),
  },
  {
    title: <DefaultHeadColumns text="Created at" />,
    dataIndex: "createdAt",
    key: "createdAt",
    render: (value: string, record: any) => (
      <TableCellWithTime
        value={value}
        key={record.id}
        className="py-0"
        format="DD-MM-YYYY"
      />
    ),
  },
  {
    title: <DefaultHeadColumns text="Address" />,
    dataIndex: "addressA",
    key: "locationId",
    render: (value: any) => (
      <DefaultTextColumn
        text={value?.locationId}
        key={value?.locationId + value.id + Math.random()}
        className="capitalize max-w-[472px] w-full truncate py-0"
      />
    ),
  },
  {
    title: "",
    dataIndex: "id",
    key: "expandable",
    render: () => (
      <div className="-rotate-90">
        <ChevronIcon />
      </div>
    ),
  },
];
export default globalQuoteStrategy;
